import React from "react";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import Top from './components/Top';
import Self from './components/Self';
import Ojisan from './components/Ojisan';
import Portfolio from './components/Portfolio';
import Piano from './components/Piano';
import Mix from './components/Mix';
import Noteblock from './components/Noteblock';
import Notfound from './components/Notfound';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={"/"} element={<Top />} />
        <Route path={"/self/"} element={<Self />} />
        <Route path={"/ojisanbot/"} element={<Ojisan />} />
        <Route path={"/portfolio/"} element={<Portfolio />} />
        <Route path={"/piano/"} element={<Piano />} />
        <Route path={"/mix/"} element={<Mix />} />
        <Route path={"/noteblock/"} element={<Noteblock />} />
        <Route path={"/*"} element={<Notfound />} />
      </Routes>
    </BrowserRouter>  
  );
}

export default App;